import * as React from "react"
import { useRef } from "react"
import { observer } from "mobx-react-lite"
import { Formik, FastField } from "formik"
import { Appearance, TextInput, ViewStyle } from "react-native"
import { FormProps } from "./form"
import * as yup from "yup"
import { TxKeyPath, translate } from "../../i18n"
import { TextField } from "../field/text-field/text-field"
import { FormControl } from "../form-control/form-control"
import { PhoneInput } from "../input/phone-input/phone-input"
import _ from "lodash"

export interface PasswordResetFormProps extends FormProps {
  initialValues?: {
    email?: string,
    phone?: string,
    isPhoneMode?: boolean
  },
}

/**
 * Describe your component here
 */
export const PasswordResetForm = observer(function PasswordResetForm(props: PasswordResetFormProps) {
  const {
    initialValues = {},
    onSubmit,
    colorScheme = "light" || Appearance.getColorScheme(),
    innerRef,
    ...rest
  } = props
  const input = {
    email: useRef<TextInput>()
  }
  const nextInput = {}

  const validationSchema = yup.object({
    // email: yup.string().email().nullable().required().label(translate("registerForm.email")),
    // phone: yup.string().ascii().max(15, translate("verificationScreen.phoneError")).nullable()
  isPhoneMode: yup.boolean().required().label(''),
  email: yup
    .string()
    .email()
    .when('isPhoneMode', {
      is: false,
      then: (schema) => schema.nullable().required(),   
      otherwise: (schema) => schema.nullable(),
    }).label(translate("registerForm.email")),
  phone: yup
    .string()
    .ascii()
    .max(15)
    .when('isPhoneMode', {
      is: true,
      then: (schema) => schema.nullable().required(),
      otherwise: (schema) => schema.nullable(), 
    }).label(translate("verificationScreen.phoneError")),
  })

  return (
    <Formik
      initialValues={{
        email: null,
        phone: null,
        isPhoneMode: false,
        ...initialValues
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {(isValid, handleSubmit) => (
        <>
          {!initialValues.isPhoneMode ? <FastField name="email">
            {({ field, form: { handleChange, handleBlur }, meta }) => (
              <FormControl
                isInvalid={!!meta.error}
                labelTx={`registerForm.${_.camelCase(field.name)}` as TxKeyPath}
                labelPreset="title3"
                colorScheme={colorScheme}
                inputProps={{
                  testID: `jala:id/${field.name}-input`,
                  ref: input[field.name],
                  autoCapitalize: "none",
                  autoComplete: "email",
                  autoCorrect: false,
                  textContentType: "emailAddress",
                  keyboardType: "email-address",
                  placeholderTx: `registerForm.${_.camelCase(field.name)}Placeholder` as TxKeyPath,
                  defaultValue: meta.initialValue,
                  onChangeText: (text) => handleChange(field.name)(text.trim()),
                  onBlur: handleBlur(field.name)
                }}
                errorMessage={meta.error}
              />
            )}
          </FastField>
          : <FastField name="phone">
            {({ field, form: { handleChange, handleBlur }, meta }) => (
              <FormControl
                isRequired
                isInvalid={!!meta.error}
                colorScheme={colorScheme}
                errorMessage={meta.error}
                // style={FORM_CONTROL}
              >
                <PhoneInput
                  colorScheme={colorScheme}
                  isInvalid={meta.touched && !!meta.error}
                  textProps={{
                    testID: `jala:id/${field.name}-input`,
                    ref: input[field.name],
                    autoCapitalize: "none",
                    autoComplete: "tel",
                    // autoCorrect: false,
                    textContentType: "telephoneNumber",
                    // keyboardType: "phone-pad",
                    onSubmitEditing: () => (isValid && handleSubmit()),
                    placeholderTx: `registerForm.${_.camelCase(field.name)}Placeholder` as TxKeyPath,
                    defaultValue: meta.initialValue,
                    // onChangeText: handleChange(field.name),
                    onBlur: handleBlur(field.name)
                  }}
                  onChangePhoneNumber={handleChange(field.name)}
                />
              </FormControl>
            )}
          </FastField>}
        </>
      )}
    </Formik>
  )
})

PasswordResetForm.displayName = 'PasswordResetForm'
